/**
 * defa.collections.SearchResults
 * A collection of SearchResult Models.
 * @version 1.2.0
 */
import SearchResult from 'scripts/defa/search-results/model-search-result';

const SearchResults = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: SearchResult,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default SearchResults;